import { compact, getSlotCompoundVariant, memo, splitProps } from '../helpers.mjs';
import { createRecipe } from './create-recipe.mjs';

const errorStateDefaultVariants = {}
const errorStateCompoundVariants = []

const errorStateSlotNames = [
  [
    "root",
    "errorState__root"
  ],
  [
    "content",
    "errorState__content"
  ],
  [
    "icon",
    "errorState__icon"
  ],
  [
    "message",
    "errorState__message"
  ],
  [
    "link",
    "errorState__link"
  ]
]
const errorStateSlotFns = /* @__PURE__ */ errorStateSlotNames.map(([slotName, slotKey]) => [slotName, createRecipe(slotKey, errorStateDefaultVariants, getSlotCompoundVariant(errorStateCompoundVariants, slotName))])

const errorStateFn = memo((props = {}) => {
  return Object.fromEntries(errorStateSlotFns.map(([slotName, slotFn]) => [slotName, slotFn.recipeFn(props)]))
})

const errorStateVariantKeys = []
const getVariantProps = (variants) => ({ ...errorStateDefaultVariants, ...compact(variants) })

export const errorState = /* @__PURE__ */ Object.assign(errorStateFn, {
  __recipe__: false,
  __name__: 'errorState',
  raw: (props) => props,
  classNameMap: {},
  variantKeys: errorStateVariantKeys,
  variantMap: {},
  splitVariantProps(props) {
    return splitProps(props, errorStateVariantKeys)
  },
  getVariantProps
})